import { render, staticRenderFns } from "./SAdminFAQAdminList.vue?vue&type=template&id=44027f8a&lang=pug"
import script from "./SAdminFAQAdminList.vue?vue&type=script&lang=js"
export * from "./SAdminFAQAdminList.vue?vue&type=script&lang=js"
import style0 from "./SAdminFAQAdminList.vue?vue&type=style&index=0&id=44027f8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports